import get from "./get";

export const Get = get;

